import { render, staticRenderFns } from "./CalendarStructure.vue?vue&type=template&id=2095515c"
import script from "./CalendarStructure.vue?vue&type=script&lang=ts"
export * from "./CalendarStructure.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports